import { notifyRequestError } from "@impero-com/common/utils/query_client";

import { useDeleteUsersUserId } from "api/generated/users/users";

// The user still has outstanding controls/control results; the caller shows a
// dedicated dialog, so suppress the generic error toast for this status.
const OUTSTANDING_ASSIGNMENTS_STATUS = 460;

export function useDeleteUserMutation() {
    return useDeleteUsersUserId({
        mutation: {
            onError: (error) => {
                if (error.response?.status === OUTSTANDING_ASSIGNMENTS_STATUS) {
                    return;
                }
                notifyRequestError(error);
            },
        },
    });
}
